function initState() {
    return {
        listingDetail: null,
        payment: null,
        pricePerMonth: 0,
        agentInfo: null,
        tourBtnList: [],
        shares: null,
        coAgent: null,
        triggerReadMore: false,
        openReadMore: false,
        company: {
            name: ''
        }
    }
}

export default {
    namespaced: true,
    state: initState,
    getters: {},
    mutations: {
        updateCompanyInfo(state, { name }) {
            state.company.name = name;
        },
        updateListingDetail(state, detail) {
            state.listingDetail = detail;
        },
        updatePayment(state, payment) {
            state.payment = payment;
        },
        updatePerMonth(state, pricePerMonth) {
            state.pricePerMonth = pricePerMonth;
        },
        updateAgentInfo(state, agentInfo) {
            state.agentInfo = agentInfo;
        },
        updateTourBtn(state, list) {
            state.tourBtnList = list;
        },
        updateShare(state, shares) {
            state.shares = shares;
        },
        updateCoAgent(state, agent) {
            state.coAgent = agent;
        },
        upTriggerReadMore(state, triggerReadMore) {
            state.triggerReadMore = triggerReadMore;
        },
        updateOpenReadMore(state, openReadMore) {
            state.openReadMore = openReadMore;
        },
        toggleOpenReadMore(state) {
            state.openReadMore = !state.openReadMore;
        }
    }
}
